module.exports = __webpack_public_path__ + "img/logo-rocket.4f3f1eef.png";